import type { FunctionComponent } from 'react';

import { Layout } from '@kanda-libs/ks-design-library';

import { ReactComponent as Lines } from 'assets/marketing-slide-up-header.svg';
import { JobButton, MobileHeader } from 'components';

import { JobLayoutProps } from '..';

const Mobile: FunctionComponent<JobLayoutProps> = function ({
  header,
  children,
  showJobCard = true,
  showLines = false,
}) {
  return (
    <Layout header={<MobileHeader />} noBorder noPadding>
      <div className="flex flex-col flex-1 -mb-6">
        {showJobCard && (
          <div className="w-full px-4 py-2 mx-auto mb-2 max-w-128">
            <JobButton />
          </div>
        )}
        <div className="flex flex-col flex-1 bg-neutral-000">
          {showLines && (
            <div className="w-full aspect-5/1 overflow-hidden">
              <div className="-skew-y-6 translate-y-2/4 h-full bg-neutral-000">
                <Lines />
              </div>
            </div>
          )}
          <div className="flex flex-col flex-1 w-full px-6 py-4 mx-auto max-w-128">
            <div className="mb-6">
              {header}
              {children}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

Mobile.displayName = 'Quote-Content-Mobile-view';

export default Mobile;
